import { useSearchParams } from "react-router-dom";
import { NXLeftArrow, NXRightArrow } from "../../icons";

interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
}

interface Edge {
  cursor: string;
  node: any;
}

interface GraphQLPaginationProps {
  edges: Edge[];
  pageInfo: PageInfo;
}

const GraphQLPagination = ({ edges, pageInfo }: GraphQLPaginationProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getDefaultPageSize = () => {
    const first = searchParams.get("first");
    const last = searchParams.get("last");
    return first || last || "20";
  };

  const pageSize = getDefaultPageSize();

  const handlePageChange = (direction: "next" | "prev") => {
    const newParams = new URLSearchParams(searchParams);

    if (direction === "next") {
      newParams.set("first", pageSize);
      newParams.set("after", pageInfo.endCursor);
      newParams.delete("before");
      newParams.delete("last");
    } else {
      newParams.set("last", pageSize);
      newParams.set("before", pageInfo.startCursor);
      newParams.delete("after");
      newParams.delete("first");
    }

    setSearchParams(newParams);
  };

  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newPageSize = event.target.value;
    const newParams = new URLSearchParams(searchParams);
    newParams.set("first", newPageSize);
    newParams.delete("after");
    newParams.delete("before");
    newParams.delete("last");
    setSearchParams(newParams);
  };

  return (
    <div className="px-10 py-6 flex flex-col justify-center gap-4 ml:flex ml:flex-row ml:items-center ml:justify-between">
      <div className="flex items-center gap-4 text-base-300">
        <label htmlFor="itemsPerPage" className="text-sm">Items per page:</label>
        <select
          id="itemsPerPage"
          value={pageSize}
          onChange={handleItemsPerPageChange}
          className="px-3 py-2 border rounded text-sm"
        >
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
      <div className="flex items-center gap-2 text-base-300">
        <button
          onClick={() => handlePageChange("prev")}
          disabled={!Boolean(searchParams.get("after")) && !pageInfo?.hasPreviousPage}
          className={`px-3 py-2 ${!Boolean(searchParams.get("after")) && !pageInfo?.hasPreviousPage ? 'bg-gray-300' : 'bg-[#0CAF60] text-white'} rounded-full`}
        >
          <NXLeftArrow className="w-5" />
        </button>
        <button
          onClick={() => handlePageChange("next")}
          disabled={!Boolean(searchParams.get("before")) && !pageInfo?.hasNextPage}
          className={`px-3 py-2 ${!Boolean(searchParams.get("before")) && !pageInfo?.hasNextPage ? 'bg-gray-300' : 'bg-[#0CAF60] text-white'} rounded-full`}
        >
          <NXRightArrow className="w-5" />
        </button>
      </div>
    </div>
  );
};

export default GraphQLPagination;
